import { NoteCategory, NoteCategoryInput, NoteInput, PersonalNote } from '../models/note.model';

export abstract class NotesRepository {
  abstract getNotes(): Promise<PersonalNote[]>;
  abstract getNote(id: number): Promise<PersonalNote | null>;
  abstract getCategories(): Promise<NoteCategory[]>;
  abstract createNote(input: NoteInput): Promise<PersonalNote>;
  abstract updateNote(id: number, input: NoteInput): Promise<PersonalNote>;
  abstract setArchived(id: number, archived: boolean): Promise<PersonalNote>;
  abstract setPinned(id: number, pinned: boolean): Promise<PersonalNote>;
  abstract deleteNote(id: number): Promise<void>;
  abstract createCategory(input: NoteCategoryInput): Promise<NoteCategory>;
  abstract updateCategory(id: number, input: NoteCategoryInput): Promise<NoteCategory>;
  abstract deleteCategory(id: number): Promise<void>;
}
